import { Component, OnInit, Input, OnChanges,
         SimpleChanges }                        from '@angular/core';
import { ActivatedRoute, Params, Router }       from '@angular/router';
import { UserService }                          from './../../../user.service';
import { SessionUser }                          from './../../../../../models/program/session-user';
import { ProgramService }                       from './../../../../../shared/services/program.service';
import { SessionDetails }                       from './../../../../../models/program/session-details';
import { ExistingUser }                         from './../../../../../models/program/existing-user';

@Component({
  selector: 'app-session-users',
  templateUrl: './session-users.component.html',
  styleUrls: ['./session-users.component.less'],
  providers: []
})

// TO DO - disable after session start
// restrict sessions you can move users to to those that haven't started?
export class SessionUsersComponent implements OnInit, OnChanges {
  @Input() session: SessionDetails;
  @Input() updated: SessionDetails;
  public users: SessionUser[];
  public userArray: number[] = [];
  public deleteSingle: boolean = false;
  public moveSingle: boolean = false;
  public selectedUser: SessionUser;
  public moveBulk: boolean = false;
  public deleteBulk: boolean = false;

  constructor(
    private userService: UserService,
    private programService: ProgramService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    console.log('session users component', this.session)
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.updated) {
      this.loadData();
    }
  }

  get selectedUsers() {
    return this.users.filter(u => this.userArray.find(id => u.id == id));
  }
  /**
   * Public Methods
   */

  public selectUser(user: SessionUser, settings?: boolean): void {
    if (this.selectedUser) { this.selectedUser = null; };
    this.selectedUser = user;
  }

  public deleteUsers(users: SessionUser[]): void {
    this.userService.deleteSessionUsers(this.session.program.id, this.session.id, users.map(u => u.id))
                .subscribe(() => {
                  this.clearUsers();
                  this.loadData();
                });
  }

  public checkUserArray(checked: boolean, id: number): void {
    if (checked) {
      this.userArray.push(id);
    } else {
      this.userArray.splice(this.userArray.indexOf(id), 1);
    }
  }

  public closeManager(recall: boolean): void {
    this.closeWindows();
    this.clearUsers();
    if (recall) {
      this.loadData();
    }
  }

  public clearUsers(): void {
    this.userArray = [];
    this.selectedUser = null;
  }

  /**
   * Private Methods
   */

  private closeWindows(): void {
    this.moveSingle = false;
    this.moveBulk = false;
    this.deleteSingle = false;
    this.deleteBulk = false;
  }

  private loadData(): void {
    this.programService
      .getSessionUsers(this.session.program.id, this.session.id)
      .subscribe(users => this.users = users);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/sessions/session/session-users/session-users.component.ts